import * as React from "react";
import { forwardRef } from "react";
const BrakesIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  fillRule: "evenodd",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M12 10.576a3.07 3.07 0 0 1 3.066 3.067A3.07 3.07 0 0 1 12 16.71a3.07 3.07 0 0 1-3.067-3.066A3.07 3.07 0 0 1 12 10.576zm0 1.5a1.57 1.57 0 0 0-1.567 1.567A1.57 1.57 0 0 0 12 15.21a1.57 1.57 0 0 0 1.566-1.566A1.57 1.57 0 0 0 12 12.076zM12 3c5.878 0 10.642 4.765 10.643 10.643a.75.75 0 0 1-.75.75h-.761c-.382 4.711-4.322 8.415-9.132 8.415a9.17 9.17 0 0 1-9.166-9.165c0-4.809 3.705-8.751 8.416-9.133v-.76A.75.75 0 0 1 12 3zm-.75 3.014a7.67 7.67 0 0 0-6.916 7.629A7.67 7.67 0 0 0 12 21.308a7.666 7.666 0 0 0 7.629-6.915h-1.346a6.33 6.33 0 0 1-12.611-.75A6.33 6.33 0 0 1 11.25 7.36V6.014zm.75 2.8a4.83 4.83 0 0 0-4.828 4.828A4.83 4.83 0 0 0 12 18.472a4.83 4.83 0 0 0 4.829-4.829A4.83 4.83 0 0 0 12 8.814zm.75-1.455a6.33 6.33 0 0 1 5.533 5.533h2.826a9.14 9.14 0 0 0-8.359-8.359v2.826z"
}));
const ForwardRef = forwardRef(BrakesIcon);
export default ForwardRef;